import { createAuthenticatedApiConfig } from "@/lib/utils.server";
import { getStatus } from "@/lib/mma";
import { createServerFn } from "@tanstack/react-start";

export const fetchStatus = createServerFn({ method: "GET" }).handler(async (): Promise<any> => {
  const config = await createAuthenticatedApiConfig();
  const response = await getStatus(config);
  const environment = process.env.ENVIRONMENT || "Unknown";
  return { ...response.data?.data, environment };
});
